import { render, staticRenderFns } from "./dangerGoodsPurchaseMine.vue?vue&type=template&id=25e95a16&scoped=true"
import script from "./dangerGoodsPurchaseMine.vue?vue&type=script&lang=js"
export * from "./dangerGoodsPurchaseMine.vue?vue&type=script&lang=js"
import style0 from "./dangerGoodsPurchaseMine.vue?vue&type=style&index=0&id=25e95a16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e95a16",
  null
  
)

export default component.exports